import { ModulesMap, ModulesConfigMap } from '@/config/data/modulesMaps'
import { _apiRequestWrap } from '../apiService'

function _getBusinessProcessesActivePlanWorks(options = {}) {
	return _apiRequestWrap(
		ModulesMap.BUSINESS_PROCESSES_ACTIVE_PLAN_WORKS,
		ModulesConfigMap[ModulesMap.BUSINESS_PROCESSES_ACTIVE_PLAN_WORKS]
			.GET_BUSINESS_PROCESSES_ACTIVE_PLAN_WORKS,
		options
	)
}

function _getBusinessProcessesActivePlanWorkPopup(options = {}) {
	return _apiRequestWrap(
		ModulesMap.BUSINESS_PROCESSES_ACTIVE_PLAN_WORKS,
		ModulesConfigMap[ModulesMap.BUSINESS_PROCESSES_ACTIVE_PLAN_WORKS]
			.GET_BUSINESS_PROCESSES_ACTIVE_PLAN_WORKS_POPUP,
		options
	)
}

function _getBusinessProcessesActivePlanWorksPreview(options = {}) {
	return _apiRequestWrap(
		ModulesMap.BUSINESS_PROCESSES_ACTIVE_PLAN_WORKS,
		ModulesConfigMap[ModulesMap.BUSINESS_PROCESSES_ACTIVE_PLAN_WORKS]
			.GET_BUSINESS_PROCESSES_ACTIVE_PLAN_WORKS_PREVIEW,
		options
	)
}

function _getBusinessProcessesActivePlanWork(options = {}) {
	return _apiRequestWrap(
		ModulesMap.BUSINESS_PROCESSES_ACTIVE_PLAN_WORKS,
		ModulesConfigMap[ModulesMap.BUSINESS_PROCESSES_ACTIVE_PLAN_WORKS]
			.GET_BUSINESS_PROCESSES_ACTIVE_PLAN_WORK,
		options
	)
}

export default {
	[ModulesConfigMap[ModulesMap.BUSINESS_PROCESSES_ACTIVE_PLAN_WORKS]
		.GET_BUSINESS_PROCESSES_ACTIVE_PLAN_WORKS]: _getBusinessProcessesActivePlanWorks,

	[ModulesConfigMap[ModulesMap.BUSINESS_PROCESSES_ACTIVE_PLAN_WORKS]
		.GET_BUSINESS_PROCESSES_ACTIVE_PLAN_WORKS_POPUP]: _getBusinessProcessesActivePlanWorkPopup,

	[ModulesConfigMap[ModulesMap.BUSINESS_PROCESSES_ACTIVE_PLAN_WORKS]
		.GET_BUSINESS_PROCESSES_ACTIVE_PLAN_WORKS_PREVIEW]: _getBusinessProcessesActivePlanWorksPreview,
        
	[ModulesConfigMap[ModulesMap.BUSINESS_PROCESSES_ACTIVE_PLAN_WORKS]
		.GET_BUSINESS_PROCESSES_ACTIVE_PLAN_WORK]: _getBusinessProcessesActivePlanWork,
}
